<template>
  <div class="app-receipt-data__container">
    <app-input
      v-cloak
      label="e-mail"
      v-if="checked"
      use-virtual-keyboard
      virtual-keyboard-type="alpha"
      :value="email"
      @input="handleEmail"
    />
    <div class="app-receipt-data__radio-wrapper">
      <app-radio v-for="(radio) in radioData" :key="radio.label" label="Чек не нужен" :radio-data="radio" @change="toggleCheck" />
    </div>
  </div>
</template>

<script>
import AppInput from '../app-input/appInput.vue'
import AppRadio from '../app-radio/appRadio.vue'
import { mapMutations, mapState } from 'vuex'
import * as mutations from '@store/types/mutations-types'

export default {
  name: 'appReceiptData',
  components: { AppInput, AppRadio },
  data() {
    return {
      checked: false,
      radioData: [
        {
          label: 'Чек не нужен',
          isDefaultChecked: true,
          groupName: 'receipt-email',
        },
        {
          label: 'Получить чек по email',
          groupName: 'receipt-email',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      email: state => state.orderDetails.email,
    }),
  },
  methods: {
    ...mapMutations({
      updateCustomerEmail: mutations.UPDATE_CUSTOMER_EMAIL,
      clearCustomerEmail: mutations.CLEAR_CUSTOMER_EMAIL,
    }),
    toggleCheck() {
      this.checked = !this.checked

      if (!this.checked) {
        this.clearCustomerEmail()
      }
    },
    handleEmail(value) {
      this.updateCustomerEmail(value)
    },
  },
  mounted() {
    this.clearCustomerEmail()
  }
}
</script>

<style>
.app-receipt-data__container {
  gap: 15px;
  height: 105px;
  position: relative;
}

.app-receipt-data__radio-wrapper {
  display: flex;
  gap: 15px;
  position: absolute;
  bottom: 0;
}
</style>
